import { render, staticRenderFns } from "./upload-image-new.vue?vue&type=template&id=8d7fedd6&"
import script from "./upload-image-new.vue?vue&type=script&lang=js&"
export * from "./upload-image-new.vue?vue&type=script&lang=js&"
import style0 from "./upload-image-new.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-image-new.vue"
export default component.exports